// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.placeholder {\n\tcolor: rgba(16, 16, 16, 0.65);\n\tfont-size: 20rpx;\n\tfont-family: PingFangSC-light;\n}\n", ""]);
// Exports
module.exports = exports;
